export const getAvatarOverrides = theme => {
  return {
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.secondary.contrastText,
          width: 50,
          height: 50,
          boxShadow: "0px 2px 2px 0px #0000000D"
        }
      }
    }
  };
};